import { connect, MapStateToProps } from 'react-redux';
import { getIsDuperbrowseActive } from '@wix/da-shared-react/pkg/Duperbrowse/redux/selectors';
import {
  getIsMobile,
  getPagingMode,
} from '@wix/da-shared-react/pkg/publicSession/selectors';
import { AppState } from '../../../../../types/store';
import { getCurrentPage, getTotalPages } from '../../../../selectors/pageInfo';

import { Props } from './StreamPagination';
import { getEnv } from '@wix/da-react-app/pkg/client/Environment/redux/selectors';

export type StateProps = Pick<
  Props,
  | 'isDuperbrowseActive'
  | 'isInfiniteScroll'
  | 'requestUrl'
  | 'currentPage'
  | 'totalPages'
  | 'error'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const totalPages = getTotalPages(state);
  const currentPage = getCurrentPage(state);

  return {
    requestUrl: getEnv(state).requestUrl,
    isDuperbrowseActive: getIsDuperbrowseActive(state as any),
    isInfiniteScroll: getIsMobile(state) || getPagingMode(state) === 'scroll',
    currentPage,
    totalPages,
  };
};

export default connect(mapStateToProps);
